import { css } from 'emotion';
import {
	lightGrey,
	desktopMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const wrapperStyle = css({
	borderBottom: `1px solid ${lightGrey}`,
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '74px',
	margin: '0 auto',
	padding: '0 20px',
	position: 'relative',

	'& [data-component=SingleFieldForm]': {
		position: 'absolute',
		top: '50%',
		right: '20px',
		transform: 'translateY(-50%)',

		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			right: 'auto',
			left: '20px',
			width: 'calc(100% - 40px)',
			'& input': {
				width: 'calc(100% - 46px)',
			},
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/news-and-events/commonFilterBar/styles.js